/* pseudo */
